/* pseudo */
